import { getWhiteLabelConfig } from "./getWhiteLabelConfig";

let cached: boolean | null = null;

/**
 * Returns true when app runs in white-label mode (config has uuid).
 * Cached after first call.
 */
export function isWhiteLabel(): boolean {
  if (cached !== null) return cached;

  cached = Boolean(getWhiteLabelConfig().uuid);

  return cached;
}
